import { computed } from 'vue'

import { useMediaQuery } from '@vueuse/core'

import { useShoppingAssistantWeb } from '../stores/useShoppingAssistantWeb'

// Mirrors the `md` Tailwind breakpoint: below it the assistant is a full-screen
// overlay, at/above it a pinned right-edge side panel that squeezes the page.
const DESKTOP_QUERY = '(min-width: 768px)'

/**
 * Viewport regime for the web shopping-assistant, shared by the panel host (to
 * size/shape itself) and the page layout (to decide whether and how far to
 * squeeze). Keeping the breakpoints in one place stops the host and layout from
 * drifting.
 *
 * - `isDesktop` (≥768): pinned, page-squeezing side panel vs full-screen overlay.
 * - `isSqueezing`: the page is pushed by `ASSISTANT_PANEL_WIDTH_PX` whenever the
 *   panel is open on a pinned-panel (≥md) viewport.
 */
export function useShoppingAssistantViewport() {
  const store = useShoppingAssistantWeb()
  const isDesktop = useMediaQuery(DESKTOP_QUERY)

  const isSqueezing = computed(() => store.isOpen && isDesktop.value)

  return { isDesktop, isSqueezing }
}
